/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SoftwareRequirement } from "./SoftwareRequirement";
import {
  SoftwareRequirementFromJSON,
  SoftwareRequirementFromJSONTyped,
  SoftwareRequirementToJSON,
  SoftwareRequirementToJSONTyped,
} from "./SoftwareRequirement";

/**
 *
 * @export
 * @interface UpdateSoftwareBody
 */
export interface UpdateSoftwareBody {
  /**
   *
   * @type {string}
   * @memberof UpdateSoftwareBody
   */
  softwareId: string;
  /**
   *
   * @type {string}
   * @memberof UpdateSoftwareBody
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof UpdateSoftwareBody
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateSoftwareBody
   */
  url?: string | null;
  /**
   *
   * @type {string}
   * @memberof UpdateSoftwareBody
   */
  iconSlug?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof UpdateSoftwareBody
   */
  managedInEntra: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateSoftwareBody
   */
  managementUrl?: string | null;
  /**
   *
   * @type {SoftwareRequirement}
   * @memberof UpdateSoftwareBody
   */
  requirement: SoftwareRequirement;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateSoftwareBody
   */
  requiredTeamIds: Array<string>;
}

/**
 * Check if a given object implements the UpdateSoftwareBody interface.
 */
export function instanceOfUpdateSoftwareBody(
  value: object,
): value is UpdateSoftwareBody {
  if (!("softwareId" in value) || value["softwareId"] === undefined)
    return false;
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("managedInEntra" in value) || value["managedInEntra"] === undefined)
    return false;
  if (!("requirement" in value) || value["requirement"] === undefined)
    return false;
  if (!("requiredTeamIds" in value) || value["requiredTeamIds"] === undefined)
    return false;
  return true;
}

export function UpdateSoftwareBodyFromJSON(json: any): UpdateSoftwareBody {
  return UpdateSoftwareBodyFromJSONTyped(json, false);
}

export function UpdateSoftwareBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): UpdateSoftwareBody {
  if (json == null) {
    return json;
  }
  return {
    softwareId: json["softwareId"],
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    url: json["url"] == null ? undefined : json["url"],
    iconSlug: json["iconSlug"] == null ? undefined : json["iconSlug"],
    managedInEntra: json["managedInEntra"],
    managementUrl:
      json["managementUrl"] == null ? undefined : json["managementUrl"],
    requirement: SoftwareRequirementFromJSON(json["requirement"]),
    requiredTeamIds: json["requiredTeamIds"],
  };
}

export function UpdateSoftwareBodyToJSON(json: any): UpdateSoftwareBody {
  return UpdateSoftwareBodyToJSONTyped(json, false);
}

export function UpdateSoftwareBodyToJSONTyped(
  value?: UpdateSoftwareBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    softwareId: value["softwareId"],
    name: value["name"],
    description: value["description"],
    url: value["url"],
    iconSlug: value["iconSlug"],
    managedInEntra: value["managedInEntra"],
    managementUrl: value["managementUrl"],
    requirement: SoftwareRequirementToJSON(value["requirement"]),
    requiredTeamIds: value["requiredTeamIds"],
  };
}
